<div fxLayout="column" fxFill>
  <div class="tab-content" fxLayout="column" fxFlex="noshrink">
    <ng-template flex-anchor></ng-template>
  </div>
  <div fxFlex="nogrow">
    <!--phone-dashboard-footer [childRoutes]="childRoutes" fxFlex fxFill></phone-dashboard-footer-->
    <div fxFlex fxFill>
      <mat-toolbar class="ma-0 pa-0 tab-header-full-height" fxLayoutAlign="center start">
        <routable-tab-navigation-menu 
              #tabNavigationMenu 
              [childRoutes]="childRoutes" 
              [footer]="true" 
              class="footer-nav"
              color="accent"
              >
        </routable-tab-navigation-menu>
      </mat-toolbar>
    </div>
  </div>
</div>
